import GooglePayButton from '@google-pay/button-react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { APP_ENVIRONMENT, CHECKOUT_PUBLIC_KEY, GOOGLE_PAY_MERCHANT_ID } from '../../../../../const';
import CheckoutRisk from '../../../../../service/CheckoutRisk';
import { createNativeMethodToken } from '../../../../../store/slices/paymentsSlice';
import { gaEvents } from '../../../../../utils/analytics';
import { NATIVE_METHOD_PAYMENT_TYPE } from '../index';

const GooglePaymentButton = ({ price, countryCode, paymentDispatch }) => {
    const dispatch = useDispatch();
    return (
        <GooglePayButton
            environment={APP_ENVIRONMENT === 'prod' ? 'PRODUCTION' : 'TEST'}
            buttonColor={'white'}
            buttonSizeMode={'fill'}
            paymentRequest={{
                apiVersion: 2,
                apiVersionMinor: 0,
                allowedPaymentMethods: [
                    {
                        type: 'CARD',
                        parameters: {
                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                            allowedCardNetworks: ['MASTERCARD', 'VISA']
                        },
                        tokenizationSpecification: {
                            type: 'PAYMENT_GATEWAY',
                            parameters: {
                                gateway: 'checkoutltd',
                                gatewayMerchantId: CHECKOUT_PUBLIC_KEY
                            }
                        }
                    }
                ],
                merchantInfo: {
                    merchantId: GOOGLE_PAY_MERCHANT_ID,
                    merchantName: 'VEDA'
                },
                transactionInfo: {
                    totalPriceStatus: 'FINAL',
                    totalPriceLabel: 'Total',
                    totalPrice: `${price?.value}`,
                    currencyCode: price?.currency?.code,
                    countryCode: countryCode
                }
            }}
            onLoadPaymentData={async (paymentRequest) => {
                const token = JSON.parse(paymentRequest.paymentMethodData.tokenizationData.token);
                const deviceSessionId = await CheckoutRisk.getDeviceSessionId();
                dispatch(createNativeMethodToken({ type: NATIVE_METHOD_PAYMENT_TYPE.GOOGLE, token, deviceSessionId })).then((res) => {
                    const data = res?.payload;
                    if (res.meta.requestStatus === 'fulfilled' && data.success) {
                        paymentDispatch(data.data, deviceSessionId);
                    }
                });
            }}
            onClick={async () => {
                gaEvents.onGooglePay();
            }}
        />
    );
};

export default GooglePaymentButton;
